module.exports = __webpack_public_path__ + "103adabfedd8a72dd5921d4319b92d35.svg";